import { AuthUser, CapabilityRole, CapabilityType } from '@hm_app/@core/models/auth_user';
import { Macrozona, AreaVasta } from '@hm_app/@core/models/anagrafica_geo';
import { Struttura } from '@hm_app/@core/models/struttura';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Distretto, AziendaSanitaria } from '@hm_app/@core/models/anagrafica_geo';
import { RuoliUtente } from '@hm_app/@core/models/utente';

import * as _ from 'lodash-es';

@Injectable()
export class StrutturaService {

    // Observable sources
    private struttura = new BehaviorSubject<Struttura>(null);

    // Observable streams
    strutturaObservable = this.struttura.asObservable();

    // Service message commands
    passStruttura(struttura: Struttura) {
        this.struttura.next(struttura);
        // console.log(this.struttura)
    }

    distrettoForStruttura(struttura: Struttura, distretti: Map<number, Distretto>) {
        return distretti.get(struttura.distretto);
    }

    aziendaForStruttura(struttura: Struttura, aziende_sanitarie: Map<number, AziendaSanitaria>) {
        if (!struttura || !struttura.azienda_sanitaria)
            return null;
        return aziende_sanitarie.get(struttura.azienda_sanitaria);
    }

    macrozonaForDistretto(distretto: Distretto, macrozone: Map<number, Macrozona>) {
        if (!distretto || !distretto.macrozona)
            return null;

        return macrozone.get(distretto.macrozona);

    }

    area_vastaForAzienda(azienda: AziendaSanitaria, aree_vaste: Map<number, AreaVasta>) {
        if (!azienda || !azienda.area_vasta)
            return null;

        return aree_vaste.get(azienda.area_vasta);
    }


    canResetToken(user: AuthUser, struttura: Struttura) {
        if (!struttura || !user) {
            return false;
        }
        return struttura.percorso_gravidanza && this.canEdit(user, struttura);
    }

    canEdit(user: AuthUser, struttura: Struttura) {
        if (!user || !user.id) {
            return false;
        }

        if (user.isAdmin) {
            return true;
        }

        return user.isAuthorized(CapabilityRole.EDIT, CapabilityType.STRUTTURA, struttura.id) ||
            user.isAuthorized(CapabilityRole.CONTROLLO, CapabilityType.STRUTTURA, struttura.id)

    }
}
